import React from 'react';
import { formatPhoneNumber } from '@helpers';

export default function PhoneNumber({
  component: Tag = 'a',
  num = '',
  ...rest
}) {
  const displayNum = formatPhoneNumber(num);

  if (!displayNum) {
    return null;
  }

  const linkNum = num.replace(
    /(\+1)?[\s-]?\(?(\d{3})\)?[\s-]?(\d{3})[\s-]??(\d{4})/,
    '+1-$2-$3-$4'
  );

  return (
    <Tag
      href={`tel:${linkNum}`}
      {...rest}
    >
      {displayNum}
    </Tag>
  );
}
